<template>
  <nav class="navbar navbar-expand-lg navbar-light no-print">
    <div class="container-fluid px-4">
      <a class="sidebar-heading mr-4" href="/">
        <img src="/img/logo.svg" alt="" style="height: 1.75rem" />
      </a>
      <div
        class=""
        id="navbarSupportedContent"
        style="display: flex; align-items: center; width: calc(100% - 238px)"
      >
        <ul
          class="navbar-nav mr-auto mt-2 mt-lg-0"
          id="timeDate"
          v-if="date && time"
        >
          <li class="mr-3">
            <p
              class="my-0 text-bold"
              style="display: flex; align-items: center"
            >
              <i
                class="material-symbols-outlined text-primary mr-1"
                style="font-size: 1rem"
                >today</i
              >
              {{ date }}
            </p>
          </li>
          <li>
            <p
              class="my-0 text-bold"
              style="display: flex; align-items: center"
            >
              <i
                class="material-symbols-outlined text-secondary mr-1"
                style="font-size: 1rem"
                >watch_later</i
              >
              {{ time }} WIB
            </p>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
          <li class="nav-item mr-4">
            <a
              class="
                btn btn-sm btn-circle btn-icon btn-basic btn-success
                nav-link
                btn-notification
              "
              @click="() => hardRefresh()"
              role="button"
            >
              <i class="material-symbols-outlined">refresh</i>
              <!-- <span class="notification-count">3</span> -->
            </a>
          </li>
          <li class="nav-item dropdown">
            <a
              class="
                btn btn-sm btn-circle btn-icon btn-primary
                nav-link
                btn-notification
              "
              id="notificationDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="material-symbols-outlined">apps</i>
              <!-- <span class="notification-count">3</span> -->
            </a>
            <!-- <a class="ml-2 mr-3 text-secondary desktop-only" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><strong>Akses Cepat</strong></a> -->
            <div
              class="dropdown-menu dropdown-menu-right dropdown-notification"
              aria-labelledby="notificationDropdown"
            >
              <b-row class="text-center justify-content-md-center mx-2">
                <b-col
                  md="3"
                  sm="6"
                  width="6"
                  class="mb-2 mt-1 px-1 col-6"
                  v-for="(item, index) in menus"
                  v-bind:key="index + 1"
                >
                  <a
                    v-if="item.fullUrl"
                    :href="item.link"
                    target="_blank"
                    :class="`card no-box-shadow py-2 px-2 card-${item.class}`"
                  >
                    <h2 class="mt-1">
                      <i
                        :class="`material-symbols-outlined text-${item.class}`"
                        >{{ item.icon }}</i
                      >
                    </h2>
                    <h5>{{ item.label }}</h5>
                  </a>
                  <a
                    v-else-if="toReset"
                    @click="() => toReset('/' + item.link, false, true)"
                    :class="`card no-box-shadow py-2 px-2 card-${item.class}`"
                  >
                    <h2 class="mt-1">
                      <i
                        :class="`material-symbols-outlined text-${item.class}`"
                        >{{ item.icon }}</i
                      >
                    </h2>
                    <h5>{{ item.label }}</h5>
                  </a>
                  <router-link
                    v-else
                    :to="'/' + item.link"
                    :class="`card no-box-shadow py-2 px-2 card-${item.class}`"
                  >
                    <h2 class="mt-1">
                      <i
                        :class="`material-symbols-outlined text-${item.class}`"
                        >{{ item.icon }}</i
                      >
                    </h2>
                    <h5>{{ item.label }}</h5>
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </li>
          <li class="nav-item dropdown">
            <button
              class="nav-link py-0 pl-3 pr-0"
              id="accountDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div class="user-item py-0">
                <div class="user-info mr-2">
                  <div class="user-title">
                    <!-- {{username}} -->
                  </div>
                </div>
                <div class="user-avatar mr-0">
                  <img src="/img/user.jpg" />
                </div>
              </div>
            </button>
            <button
              class="dropdown-menu dropdown-menu-right dropdown-account"
              aria-labelledby="accountDropdown"
            >
              <span class="user-avatar user-avatar-xl with-role">
                <img src="/img/user.jpg" />
                <div>
                  <h4 class="avatar-name">{{ username }}</h4>
                  <p class="avatar-role">{{ role || "Admin" }}</p>
                </div>
              </span>
              <!-- <div class="dropdown-divider"></div> -->
              <!--a-- class="dropdown-item" href="/profile">
                            <i class="material-symbols-outlined">person</i>
                            My Profile
                        </!--a-->
              <!--a-- class="dropdown-item" href="/profile/change-password">
                            <i class="material-symbols-outlined">lock_open</i>
                            Change Password
                        </!--a-->
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="() => logout(toReset)">
                <i class="material-symbols-outlined">exit_to_app</i>
                Logout
              </button>
            </button>
          </li>

          <!-- <li class="nav-item ml-3">
                    <button class="nav-link btn btn-basic" @click="()=>logout()">Logout</button>
                </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
//import {HTTP,username,roleLabel} from '@/config.js';
// //import jQuery from 'jquery';
// //import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "Navbar",
  props: {
    msg: String,
    toReset: Function,
  },
  data: () => {
    return {
      fromUrl: "",
      date: "",
      time: "",
      username: "",
      role: "",
      menus: [],
    };
  },
  methods: {
    hardRefresh: function() {
      location.reload();
    },
    logout: async function(callback) {
      await this.$store.state.HTTP.get("auth/logout");
      try {
        this.$store.dispatch("logout");
        if (callback) {
          callback();
        }
        this.$router.push("/login");
        // this.$router.go();
      } catch (e) {
        ////console.log(e);
      }
    },
  },
  mounted: async function() {
    this.username = this.$store.state.username;
    this.role = this.$store.state.roleLabel;
    this.roleId = this.$store.state.role;
    this.menus = this.$store.state.menus.filter((menu) =>
      menu.authorized.includes(this.roleId)
    );
    ////console.log(this.menus);
    let self = this;
    let today = new Date();
    self.date = today.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    let hours =
      today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
    let minutes =
      today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
    self.time = hours + ":" + minutes;
    setInterval(function() {
      today = new Date();
      self.date = today.toLocaleDateString("id-ID", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
      hours = today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
      minutes =
        today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
      self.time = hours + ":" + minutes;
    }, 60000);
  },
};
</script>
